package com.karawek.core.ui.components

import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreTheme

@Composable
fun CoreIconButton(
    icon: ImageVector,
    contentDescription: String?,
    enabled: Boolean = true,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    IconButton(
        onClick = onClick,
        modifier = modifier,
        enabled = enabled,
        colors = IconButtonColors(
            containerColor = CoreTheme.colors.background,
            contentColor = CoreTheme.colors.primary,
            disabledContainerColor = CoreTheme.colors.surfaceVariant.copy(alpha = CoreAlphas.DisabledSurface),
            disabledContentColor = CoreTheme.colors.onBackground.copy(alpha = CoreAlphas.Disabled),
        ),
        content = {
            Icon(
                imageVector = icon,
                contentDescription = contentDescription,
                tint = if (enabled) CoreTheme.colors.onBackground else CoreTheme.colors.onBackground.copy(alpha = CoreAlphas.Disabled),
                modifier = modifier,
            )
        }
    )
 }
